import {useSiteEnvironmentContext} from 'hooks'

export function useIsYouth() {
  return useSiteEnvironmentContext().IS_YOUTH_DOMAIN
}
